import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { useStore } from 'src/contexts/StoreContext';
import { styles } from './ToolOptionTooltip.styles';
import { BaseHoverTooltip } from '@photosi/rn-components/tooltips/base-hover-tooltip/BaseHoverTooltip';
import { useMemo } from 'react';
import { getHintI18nKey } from 'src/_shared/utils/getI18nKeys';
import { ToolOptionTooltipProps } from './ToolOptionTooltip.types';

export const ToolOptionTooltip = observer(({ hint, ...props }: ToolOptionTooltipProps) => {
  const { i18n } = useStore();

  const TooltipContent = useMemo(() => {
    return hint
      ? () => (
          <Animated.View
            entering={FadeIn.duration(200)}
            exiting={FadeOut.duration(200)}
            style={styles.hoverTextContainer}
            pointerEvents="none"
          >
            <TextLato style={styles.hoverText} key={hint}>
              {i18n.t(getHintI18nKey(hint))}
            </TextLato>
          </Animated.View>
        )
      : undefined;
  }, [hint]);

  return <BaseHoverTooltip TooltipContent={TooltipContent} {...props} />;
});
